import { useSelector, useDispatch } from 'react-redux'

import { SHOP_CLAIM, TOKEN_ACC } from '../../app/constants'
import { setPopUp } from '../../features/popUpSlice/popUpSlice'

const useWax = () => {
  const user = useSelector((state) => state.user.userAccount)
  const balance = useSelector((state) => state.balance)
  const dispatch = useDispatch()

  const popUpHandler = (status) => {
    dispatch(
      setPopUp({
        isOpen: true,
        status,
      }),
    )
  }

  const action = async (details) => {
    try {
      const result = user.signTransaction(
        {
          actions: details,
        },
        {
          blocksBehind: 3,
          expireSeconds: 1200,

          broadcast: true,
        },
      )

      console.log(await result)
      popUpHandler('Sucess')
    } catch (error) {
      console.log(await error)
      popUpHandler('Error')
    }
  }

  const claim = async (type) => {
    const details = [
      {
        account: 'gtokenstakin',
        name:
          type === 'NFT'
            ? 'claimexprnft'
            : type === 'GLK'
            ? 'claimexprstk'
            : null,
        authorization: [
          {
            actor: user.accountName,
            permission: user.requestPermission,
          },
        ],
        data: {
          wallet: user.accountName,
        },
      },
    ]
    action(details)
  }

  const stakeGLK = async (epochId, civilizationId, missionId, amount) => {
    const details = [
      {
        account: 'gtokentest11',
        name: 'transfer',
        authorization: [
          {
            actor: user.accountName,
            permission: user.requestPermission,
          },
        ],
        data: {
          from: user.accountName,
          to: 'gtokenstakin',
          quantity: `${amount}.00000000 GLK`,
          memo: `stake token@${epochId}@${civilizationId}@${missionId}`,
        },
      },
    ]

    action(details)
  }

  const buyAction = (item_id, price, qty) => {
    console.log(
      'SHOPPING:',
      item_id,
      price,
      qty,
      price.split(" ")[0],
      parseInt(price.split(" ")[0]) * qty,
      `${(parseInt(price.split(" ")[0]) * qty).toFixed(8)} ${price.split(" ")[1]}`,
    )

    if (balance.GLK < parseInt(price) * qty) {
      return
    }

    const depositAction = {
      account: TOKEN_ACC,
      name: 'transfer',
      authorization: [
        {
          actor: user.accountName,
          permission: user.requestPermission,
        },
      ],
      data: {
        from: user.accountName,
        to: SHOP_CLAIM,
        quantity: `${(parseInt(price) * qty).toFixed(8)} ${price.split(" ")[1]}`,
        memo: `deposit`,
      },
    }

    const claimAction = {
      account: SHOP_CLAIM,
      name: 'buyitem',
      authorization: [
        {
          actor: user.accountName,
          permission: user.requestPermission,
        },
      ],
      data: {
        wallet: user.accountName,
        template_id: item_id,
      },
    }

    const groupArr = new Array(qty).fill(claimAction)

    action([depositAction, ...groupArr])
  }

  return { claim, stakeGLK, buyAction }
}

export default useWax
